<mat-form-field appearance="outline" class="w-100" color="primary" subscriptSizing="dynamic">
    <mat-label>{{ title }}</mat-label>
    <input [disabled]="disabled" [formControl]="timelineSearchControl"
           [matAutocomplete]="auto"
           [placeholder]="placeholder" [readonly]="disabled" matInput>
    <mat-autocomplete #auto="matAutocomplete"
                      (optionSelected)='selectTimelineById($event.option.value.id)'
                      [displayWith]="displayFn">
        @for (timeline of filteredTimelines; track timeline.id) {
            <mat-option [value]="timeline">
                {{ nameDisplay(timeline) }}
            </mat-option>
        }
    </mat-autocomplete>
    @if (timelineSearchControl?.value?.id && !disabled) {
        <button (click)="this.timelineSearchControl.setValue(null); this.timelineSelect.emit(undefined);"
                aria-label="Clear Search" mat-icon-button
                matSuffix>
            <mat-icon>close</mat-icon>
        </button>
    }
    @if (loading) {
        <mat-icon matSuffix>
            <mat-spinner color="primary"></mat-spinner>
        </mat-icon>
    }
    @if (timelineSearchControl.value?.length < 3) {
        <mat-hint>A minimum of 3 characters is required to search
        </mat-hint>
    }
</mat-form-field>
